<template>
  <div class="content-body">
    <el-select v-model="value" placeholder="请选择" size="small">
      <el-option label="转入资金" value="zijin"></el-option>
    </el-select>
    <el-date-picker
      style="margin-left: 20px;"
      v-model="value1"
      size="small"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <div style="margin-top: 30px;">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" align="center" label="时间"></el-table-column>
        <el-table-column prop="name" align="center" label="转账类型"></el-table-column>
        <el-table-column prop="address" align="center" label="金额"></el-table-column>
        <el-table-column prop="address" align="center" label="备注"></el-table-column>
      </el-table>
      <div class="page-c">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: 'zijin',
      value1: '',
      tableData: [{
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-08',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-06',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }, {
                date: '2016-05-07',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
              }],
      page: 1,
      pageSize: 10,
      pageTotal: 1,
    };
  },
  mounted() {
    this.user_info = JSON.parse(sessionStorage.getItem('user_info'));
    setTimeout(() => {
      this.$function.hiddenLoading();
    }, 200);
  },
  methods: {
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
  }
};
</script>
<style lang="less" scoped>
  .page-c {
    background: #fff;
    padding: 20px;
  }
</style>
